import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LeftNavList from './LeftNavList';

class LeftNav extends Component {
  state = {
    activeParentNav: {},
  }

  UNSAFE_componentWillMount() {
    const { navItems } = this.props;
    const activeParentNav = Object.assign({}, this.state.activeParentNav);
    activeParentNav[navItems[0].name] = true;
    this.setState({ activeParentNav });
  }

  toggleParentNav = navName => {
    const activeParentNav = Object.assign({}, this.state.activeParentNav);
    if (activeParentNav[navName]) {
      activeParentNav[navName] = false;
    } else {
      activeParentNav[navName] = true;
    }
    this.setState({ activeParentNav });
  }


  render() {
    const { navItems, setSupportNav } = this.props;
    const { activeParentNav } = this.state;
    return (
      <LeftNavList
        navItems={navItems}
        setSupportNav={setSupportNav}
        activeParentNav={activeParentNav}
        toggleParentNav={this.toggleParentNav}
      />
    );
  }
}

LeftNav.propTypes = {
  navItems: PropTypes.instanceOf(Array),
  setSupportNav: PropTypes.func,
};

export default LeftNav;
